import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useInAndOutModel } from "../inAndOutModel";
import { IInAndOutDetail } from "../inAndOutTypes";
import moment, { Moment } from "moment";
import { formatNum, momentFormat } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useNavModel } from "@/model/navModel";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, descRows,
        loadData, setSelectedRowKeys, setDescRows
    } = useInAndOutModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const onLook = (record: IInAndOutDetail) => {
        let { tradeCode, tradeTypeCode } = record
        if (tradeTypeCode === "trade-type.maintenance") {//维修工单
            return replaceNav(selectedNavId, "2-2-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.sale-return") {//销售退货
            return replaceNav(selectedNavId, "2-4-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.sale") {//销售单
            return replaceNav(selectedNavId, "2-3-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.purchase") {//采购单
            return replaceNav(selectedNavId, "3-1-3", { id: tradeCode as string, mode: "look", }, true);
        }
        if (tradeTypeCode === "trade-type.purchase-return") {//采购退货
            return replaceNav(selectedNavId, "3-2-3", { id: tradeCode as string, mode: "look", }, true);
        }
    }
    const columns: ColumnsType<IInAndOutDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 60,
            render: (text, record, index) => `${index + 1}`,
            fixed: "left"
        }, {
            // title: '单据编码',
            title: Locale["Document No."],
            width: 150,
            dataIndex: 'tradeCode',
            fixed: "left",
            render: (text, record) => <span onClick={() => onLook(record)} className="click-span">{text}</span>
        }, {
            // title: '单据类型',
            title: Locale["Document  Type"],
            width: 160,
            dataIndex: 'tradeTypeCode',
            ellipsis: true,
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '出入类型',
            title: Locale["Stock-io Type"],
            width: 100,
            dataIndex: 'ioFlag',
            render: text => text == 0 ? Locale['Stock out'] : Locale['Stock in']
        }, {
            // title: '出/入库日期',ioFlag: 1
            title: Locale["Stock-io Time"],
            width: 150,
            dataIndex: 'createTime',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{momentFormat(text)}</p></Tooltip>,
        }, {
            // title: '商品编码',
            title: Locale["Material Code"],
            width: 100,
            dataIndex: 'materialCode',
        }, {
            // title: '商品名称',
            title: Locale["Material Name"],
            width: 160,
            dataIndex: 'materialName',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '仓库',
            title: Locale["Warehouse"],
            width: 120,
            dataIndex: 'warehouseName',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '货位',
            title: Locale["Shelf"],
            ellipsis: true,
            width: 160,
            dataIndex: 'shelfCode',
            render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '数量',
            title: Locale["Qty"],
            width: 130,
            dataIndex: 'num',
        }, {
            // title: '单价',
            title: Locale["Unit Price"],
            width: 130,
            dataIndex: 'price',
        }, {
            // title: '金额'
            title: Locale["Amount"],
            width: 130,
            dataIndex: 'amount',
        }, {
            // title: '折后单价',Amount after discount
            title: Locale["Amount after discount"],
            width: 130,
            dataIndex: 'amount',
            render: (text, record) => record.discountRate == 0 ? text : formatNum(Number(record.discountRate) * Number(record.price) / 100)
        }, {
            // title: '结算方式',
            title: Locale["Payment Method"],
            width: 130,
            dataIndex: 'payType',
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '开单员',
            title: Locale["Creator"],
            width: 130,
            dataIndex: 'billingClerk',
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            width: 130,
            dataIndex: 'createUser',
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            width: 130,
            dataIndex: 'reckoner',
        },
    ];


    useEffect(() => {
        loadData()
    }, [])

    //点击行选高亮
    const onRow = (record: IInAndOutDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IInAndOutDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record)
            })}
            scroll={{ x: 'max-content', y: 500 }}
        />
    )
}
